export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9735.d9f7c469.jpg";